<template>
    <div class="rel mt30">
    <!-- <h1>简历基础信息</h1> -->

        <!--编辑状态-->
        <div v-if="editStatus.id==baseInfo.id && editStatus.status==true">
            <div v-if="resumeEditStatus==true && resumeBaseInfoEditStatus==true">
                <base-info-form :form="form" :editStatus="editStatus" ></base-info-form>
            </div>
        </div>

        <!--非编辑状态-->
        <div class="resumeBase" v-else>
            <!--编辑按钮-->
            <div class="editBtn">
                <el-button v-if="!resumeEditStatus" type="text" icon="el-icon-edit-outline"
                           @click="edit(baseInfo)" v-has-permi="['resume:info:edit']">
                </el-button>
            </div>

            <el-row class="pOverview">
                <el-col :span="4">
                    <!--头像-->
                    <div class="uImg">
                        <img v-if="baseInfo.avatar" :src="location(baseInfo.avatar)"/>
                        <div v-else class="noImg"><i class="el-icon-user-solid"></i></div>
                    </div>
                </el-col>
                <el-col :span="20">
                    <!--用户名-->
                    <h1>{{baseInfo.username}}</h1>
                    <p class="tit">
                        <!--性别-->
                        <span>
                            <span>{{ dictFormatter(genderOptions, baseInfo.gender) }}</span>
                        </span>
                        <!--年龄-->
                        <span>{{this.getAge()}}岁</span>
                        <!--现居住地-->
                        <span>{{baseInfo.address?baseInfo.address.join(''):''}}</span>
                        <!--工作经验-->
                        <span>{{baseInfo.exp}}</span>
                        <!--政治面貌-->
                        <span>
                            <span>{{ dictFormatter(politicalStatusOptions, baseInfo.politicalStatus) }}</span>
                        </span>
                    </p>
                    <!--个人优势-->
                    <div class="cTxt" v-html="preText(baseInfo.selfEvaluation)"></div>
                </el-col>
            </el-row>

            <el-divider></el-divider>

            <el-row>
                <el-col :span="4" class="resumeItem">
                    <h1>联系方式</h1>
                </el-col>
                <el-col :span="20">
                    <el-col :span="12">{{baseInfo.mobilePhone}}</el-col>
                    <el-col :span="12">{{baseInfo.email}}</el-col>
                </el-col>
            </el-row>

            <el-divider></el-divider>

            <el-row>
                <el-col :span="4" class="resumeItem">
                    <h1>求职意向</h1>
                </el-col>
                <el-col :span="20">
                    <el-col :span="12">
                        <p><b class="expectPosition">{{baseInfo.expectPosition?baseInfo.expectPosition.join('/'):''}}</b></p>
                        <p>
                            <span>工作性质：</span>
                            <span>{{ dictFormatter(willNatureOptions, baseInfo.willNature) }}</span>
                        </p>
                        <p>
                            <span>工作地区：</span>
                            <span>{{baseInfo.city?baseInfo.city.join(''):''}}</span>
                        </p>
                    </el-col>
                    <el-col :span="12">
                        <p><b>{{baseInfo.willSalaryStart}}-{{baseInfo.willSalaryEnd}}元/月</b></p>
                        <p>
                            <span>期望行业：</span>
                            <span>{{baseInfo.expectIndustry?baseInfo.expectIndustry.join('/'):''}}</span>
                        </p>
                        <p>
                            <span>到岗时间：</span>
                            <span>{{baseInfo.arrivalTime}}</span>
                        </p>
                    </el-col>
                </el-col>
            </el-row>

        </div>
    </div>
</template>
<script>
    import BaseInfoForm from './Form/BaseInfoForm.vue';
    import {saveResumeBaseInfo} from '@/api/resume';
    import {getTreeListByDictType} from '@/api/dict';

    export default {
        props: ['baseInfo'],
        components: {
            BaseInfoForm,
        },
        data(){
            return {
                // 表单编辑状态
                editStatus: {
                    id: 0,
                    status: false,
                },
                // 简历基础信息表单
                form: {},
                genderOptions: [],  // 性别
                politicalStatusOptions: [],    // 政治面貌
                willNatureOptions: [],  // 工作性质
            }
        },
        created() {
            this.loadDictData();
        },
        computed: {
            location(){
                return function (avatar){
                    let imagePath = encodeURI(avatar);
                    return `/files?imagePath=${imagePath}`;
                }
            },
            // 简历编辑状态
            resumeEditStatus(){
                return this.$store.state.index.resumeEditStatus;
            },
            // 简历工作经历编辑状态
            resumeBaseInfoEditStatus(){
                return this.$store.state.index.resumeBaseInfoEditStatus;
            },
        },
        methods:{
            loadDictData(){
                getTreeListByDictType("sex").then(response => {
                    this.genderOptions = response.data
                });
                getTreeListByDictType("political_outlook").then(response => {
                    this.politicalStatusOptions = response.data
                });
                getTreeListByDictType("work_nature").then(response => {
                    this.willNatureOptions = response.data
                });
            },
            // 表单进入编辑状态
            edit(item){
                this.add();
                this.form = Object.assign({}, item);
                this.editStatus.id = item.id;
                this.editStatus.status = true;
            },
            // 简历工作经历表单切换至编辑状态
            add() {
                this.form = {};
                this.$store.commit('changeResumeEditStatus', true);
                this.$store.commit('changeResumeBaseInfoEditStatus', true);
            },
            getEditStatus(data) {
                this.editStatus = data;
            },

            // 出生日期换算年龄
            getAge() {
                //出生时间 毫秒
                var birthDayTime = new Date(this.baseInfo.birthday).getTime();
                //当前时间 毫秒
                var nowTime = new Date().getTime();
                //一年毫秒数(365 * 86400000 = 31536000000)
                return Math.ceil((nowTime-birthDayTime)/31536000000);
            },
            preText (pretext) {
                if(pretext){
                    return pretext.replace(/\r\n/g, '<br/>').replace(/\n/g, '<br/>').replace(/\s/g, '&nbsp;')
                }else{
                    return ''
                }
            }
        }
    }
</script>